import React from "react";
import { Trash2, ShoppingCart, Plus, Minus, Package } from 'lucide-react';
import { serverURL } from "../../services/NodeServices";

const ProductList = ({ topProducts, setCart, setTopProducts, generateBill }) => {
  
  const handleRemove = (variant_id) => {
    const updatedCart = topProducts.filter(
      (item) => item.variant.variant_id !== variant_id
    );
    setCart(updatedCart);
    setTopProducts(updatedCart);
    generateBill();
  };

  const handleQuantityChange = (variant_id, change) => {
    const updatedCart = topProducts.map((cartItem) => {
      if (cartItem.variant.variant_id === variant_id) {
        const newQuantity = Math.max(1, cartItem.quantity + change);
        return { ...cartItem, quantity: newQuantity };
      }
      return cartItem;
    });
    setCart(updatedCart);
    setTopProducts(updatedCart);
    generateBill();
  };

  return (
    <>
      {topProducts.length !== 0 ? (
        <div className="space-y-2">
          {topProducts?.map((item, index) => (
            <div
              className="bg-white border border-gray-100 rounded-lg p-3 relative hover:border-gray-200 transition-all duration-200"
              key={item.variant.product_id}
            >
              <div className="flex gap-3">
                {/* Product Image */}
                <div className="w-16 h-16 bg-gray-50 rounded-lg flex items-center justify-center border border-gray-100 overflow-hidden flex-shrink-0">
                  {item.variant.image_url ? (
                    <img 
                      src={`${serverURL}images/${item.variant.image_url.split(",")[0]}`}
                      alt={item.variant.variantname}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <Package className="w-5 h-5 text-gray-400" />
                  )}
                </div>
                
                {/* Product Details */}
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-gray-900 text-sm mb-1 truncate">
                    {item.variant.variantname}
                  </h3>
                  
                  {/* Price Section */}
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-sm font-semibold text-gray-900">
                      ₹{item.variant.current_price}
                    </span>
                    {item.variant.price !== item.variant.current_price && (
                      <span className="text-xs text-gray-400 line-through">
                        ₹{item.variant.price}
                      </span>
                    )}
                  </div>
                  
                  {/* Size and Color */}
                  <div className="flex items-center gap-2 text-xs text-gray-500 mb-2">
                    <span className="bg-gray-50 px-2 py-0.5 rounded text-xs">
                      Size {item.variant.size}
                    </span>
                    {item.variant.color && (
                      <span className="bg-gray-50 px-2 py-0.5 rounded text-xs">
                        {item.variant.color}
                      </span>
                    )}
                  </div>

                  {/* Quantity Controls */}
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-medium text-gray-600">Qty:</span>
                    <div className="flex items-center border border-gray-200 rounded overflow-hidden bg-white">
                      <button
                        className="p-1 hover:bg-gray-50 transition-colors border-r border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => handleQuantityChange(item.variant.variant_id, -1)}
                        disabled={item.quantity <= 1}
                      >
                        <Minus className="w-3 h-3" />
                      </button>
                      
                      <span className="px-2 py-1 text-xs font-medium min-w-[2rem] text-center">
                        {item.quantity}
                      </span>
                      
                      <button
                        className="p-1 hover:bg-gray-50 transition-colors border-l border-gray-200"
                        onClick={() => handleQuantityChange(item.variant.variant_id, 1)}
                      >
                        <Plus className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                </div>
                
                {/* Remove Button */}
                <button
                  className="absolute top-2 right-2 p-1.5 text-gray-300 hover:text-red-500 hover:bg-red-50 rounded transition-colors duration-200"
                  onClick={() => handleRemove(item.variant.variant_id)}
                  aria-label="Remove item from cart"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
          <div className="w-16 h-16 mb-4 text-gray-300">
            <ShoppingCart size={64} className="w-full h-full" />
          </div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2">
            Your cart is empty
          </h3>
          <p className="text-gray-500 text-sm">
            Add some items to get started
          </p>
        </div>
      )}
    </>
  );
};

export default ProductList;